import { LeaksInbox } from "@/screens/leaks/LeaksInbox";
import { AnalyticsSurface } from "@/screens/analytics/AnalyticsSurface";
import { AuditTrail } from "@/screens/audit/AuditTrail";
import { useAuditEvents } from "@/domain/hooks";

export function LeaksTab() {
  return <LeaksInbox />;
}

export function AnalyticsTab() {
  return <AnalyticsSurface scopeLabel="Uganda Fire Stations" />;
}

export function AuditTrailTab() {
  return <AuditTrail events={useAuditEvents()} />;
}
